<template>
  <div class="slide-verify-box">
    <!-- 背景图区域 -->
    <div class="slide-bg" ref="bgRef">
      <!-- 缺口位置 -->
      <div class="slide-gap" :style="{left: gapLeft + 'px'}"></div>
      <!-- 滑动块 -->
      <div 
        class="slide-block" 
        ref="blockRef"
        :style="{left: moveX + 'px'}"
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <span v-if="!isSuccess">≫</span>
        <span v-else>✓</span>
      </div>
    </div>
    <!-- 底部滑动条 -->
    <div class="slide-track">
      <div class="slide-progress" :style="{width: moveX + 'px'}"></div>
      <div class="slide-text">{{ isSuccess ? '验证成功' : '向右滑动完成验证' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlideVerify',
  props: {
    // 误差容错值
    tolerance: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      moveX: 0, // 滑块当前偏移
      gapLeft: 0, // 缺口位置
      trackWidth: 0, // 滑道总宽度
      isDrag: false,
      isSuccess: false,
      bgWidth: 340,
      bgHeight: 160
    }
  },
  mounted() {
    this.initVerify()
    // 监听鼠标全局事件
    document.addEventListener('mousemove', this.onDrag)
    document.addEventListener('mouseup', this.stopDrag)
    document.addEventListener('touchmove', this.onDrag)
    document.addEventListener('touchend', this.stopDrag)
  },
  beforeDestroy() {
    // 销毁解绑事件
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    document.removeEventListener('touchmove', this.onDrag)
    document.removeEventListener('touchend', this.stopDrag)
  },
  methods: {
    // 初始化、重置验证
    initVerify() {
      this.isSuccess = false
      this.moveX = 0
      // 随机缺口位置 60 ~ 260
      this.gapLeft = Math.floor(Math.random() * 200) + 60
      this.$nextTick(() => {
        this.trackWidth = this.$refs.bgRef.clientWidth
      })
    },
    // 按下开始拖拽
    startDrag(e) {
      if (this.isSuccess) return
      this.isDrag = true
      e.preventDefault()
    },
    // 拖拽移动
    onDrag(e) {
      if (!this.isDrag || this.isSuccess) return
      // 鼠标坐标兼容pc/移动端
      let clientX = e.clientX || e.touches[0].clientX
      const rect = this.$refs.bgRef.getBoundingClientRect()
      let x = clientX - rect.left - 20
      // 限制左右边界
      if (x < 0) x = 0
      if (x > this.trackWidth - 40) x = this.trackWidth - 40
      this.moveX = x
    },
    // 松开停止拖拽，校验
    stopDrag() {
      if (!this.isDrag) return
      this.isDrag = false
      // 判断是否对齐缺口
      const diff = Math.abs(this.moveX - this.gapLeft)
      if (diff <= this.tolerance) {
        this.isSuccess = true
        this.$emit('success') // 验证成功抛出事件
      } else {
        // 验证失败回弹
        setTimeout(() => {
          this.moveX = 0
        }, 300)
      }
    },
    // 外部调用重置
    reset() {
      this.initVerify()
    }
  }
}
</script>

<style scoped lang="scss">
.slide-verify-box {
  width: 100%;
  margin: 16px 0;
  .slide-bg {
    position: relative;
    width: 100%;
    height: 160px;
    background: #e8f4fc;
    border-radius: 8px;
    overflow: hidden;
    user-select: none;
    // 缺口方块
    .slide-gap {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      background: #fff;
      border: 2px solid #0E71BC;
      border-radius: 4px;
    }
    // 滑块
    .slide-block {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      background: #0E71BC;
      border-radius: 4px;
      color: #fff;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: grab;
      transition: background 0.2s;
      &:active {
        cursor: grabbing;
      }
    }
  }
  // 底部滑动轨道
  .slide-track {
    position: relative;
    width: 100%;
    height: 42px;
    margin-top: 8px;
    background: #D8ECFB;
    border-radius: 4px;
    overflow: hidden;
    .slide-progress {
      height: 100%;
      background: #a9d8f7;
      transition: none;
    }
    .slide-text {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #666;
      pointer-events: none;
    }
  }
}
</style>